import React from "react";
import { SiteLayout } from "@/components/layout/SiteLayout";

const LegalWrap = ({ children }) => (
  <SiteLayout>
    <section className="brp-paper">
      <div className="mx-auto max-w-3xl px-5 sm:px-8 py-16 sm:py-24">
        {children}
      </div>
    </section>
  </SiteLayout>
);

const H = ({ children }) => <h2 className="mt-10 text-xl sm:text-2xl font-display font-semibold tracking-tight text-[hsl(var(--brp-ink-on-paper))]">{children}</h2>;
const P = ({ children }) => <p className="mt-3 text-[15px] leading-relaxed text-[hsl(var(--brp-ink-muted-on-paper))]">{children}</p>;

export default function PrivacyPage() {
  const year = new Date().getFullYear();
  return (
    <LegalWrap>
      <div className="text-[11px] tracking-[0.28em] uppercase text-[hsl(var(--brp-orange))]">Legal</div>
      <h1 data-testid="legal-page-title" className="mt-3 text-3xl sm:text-4xl font-display font-semibold tracking-tight text-[hsl(var(--brp-ink-on-paper))]">Privacy Policy</h1>
      <p className="mt-2 text-sm text-[hsl(var(--brp-ink-muted-on-paper))]">Effective January 1, {year}</p>

      <P>
        Brilliant Regular People Tech (“BRP Tech,” “we,” “us,” or “our”) respects your privacy and is committed to protecting the personal information you share with us. This Privacy Policy explains how we collect, use, and safeguard information when you visit brptech.com or interact with our services.
      </P>

      <H>Information We Collect</H>
      <P>We collect information you voluntarily provide when you contact us, subscribe to updates, request a conversation, submit a Talent Network application, or purchase a product or service. This may include your name, organization, email address, phone number, resume or portfolio, and any details you choose to share about your project or goals.</P>
      <P>We also automatically collect limited technical information such as IP address, browser type, device information, referring URL, and pages visited. This information helps us maintain, secure, and improve our website.</P>

      <H>How Information Is Used</H>
      <P>We use the information you provide to respond to inquiries, schedule conversations, deliver services, evaluate opportunities to work together, process payments, send requested communications, and improve our website experience. We do not sell your personal information.</P>

      <H>Cookies and Tracking Technologies</H>
      <P>We use cookies and similar technologies to remember preferences, analyze site traffic, and measure the effectiveness of our content. You may adjust your browser settings to disable cookies, though some features may not function properly if disabled.</P>

      <H>Third-Party Services</H>
      <P>We may share limited information with trusted third-party service providers who help us operate the website, deliver services, process payments, and analyze usage. These providers are bound by confidentiality obligations and may only use information for the purposes we specify.</P>

      <H>Analytics</H>
      <P>We use privacy-respecting analytics tools to understand how visitors use our site and to improve the experience. Aggregated analytics data does not identify individual users.</P>

      <H>Payment Processing</H>
      <P>When you purchase a product or service, payments are processed by trusted third-party payment processors such as Stripe. Payment card details are handled by the processor and are not stored on our systems.</P>

      <H>Email Communications</H>
      <P>If you opt in to receive updates or newsletters, we will send you information you have requested. You may unsubscribe at any time using the link included in every email.</P>

      <H>Data Security</H>
      <P>We implement reasonable technical and organizational safeguards to protect your information from unauthorized access, disclosure, alteration, or destruction. However, no method of transmission or electronic storage is 100% secure.</P>

      <H>Data Retention</H>
      <P>We retain personal information only for as long as necessary to fulfill the purposes described in this policy, comply with legal obligations, resolve disputes, and enforce our agreements.</P>

      <H>Children’s Privacy</H>
      <P>Our services are not directed to children under the age of 13, and we do not knowingly collect personal information from children.</P>

      <H>Your Rights</H>
      <P>Depending on your jurisdiction, you may have the right to access, correct, or delete personal information we hold about you, or to object to certain processing activities. To exercise these rights, please contact us using the information below.</P>

      <H>Changes to This Privacy Policy</H>
      <P>We may update this Privacy Policy from time to time. When we make material changes, we will update the effective date above and, where appropriate, provide additional notice.</P>

      <H>Contact Information</H>
      <P>If you have questions about this Privacy Policy, please contact us at privacy@brptech.com.</P>
    </LegalWrap>
  );
}
